import {
	AlertDiamondIcon,
	Tick02Icon,
	Time04Icon,
} from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { Badge } from "@/components/ui/badge";

interface CheckStatusBadgeProps {
	checked: boolean;
	checkExpiresAt?: string | null;
	checkExpiringSoon?: boolean;
}

function isExpired(expiresAt: string | null | undefined): boolean {
	if (!expiresAt) return false;
	return new Date(expiresAt) < new Date();
}

function isExpiringSoon(
	checkExpiringSoon: boolean | undefined,
	checkExpiresAt: string | null | undefined,
	daysThreshold = 30,
): boolean {
	if (checkExpiringSoon !== undefined) {
		return checkExpiringSoon;
	}
	if (!checkExpiresAt) return false;
	const expiresAt = new Date(checkExpiresAt);
	const threshold = new Date();
	threshold.setDate(threshold.getDate() + daysThreshold);
	return expiresAt <= threshold && expiresAt >= new Date();
}

export function CheckStatusBadge({
	checked,
	checkExpiresAt,
	checkExpiringSoon,
}: CheckStatusBadgeProps) {
	// Not checked
	if (!checked) {
		return <Badge variant="secondary">Nezkontrolováno</Badge>;
	}

	// Checked - check expiration status
	const hasExpired = isExpired(checkExpiresAt);
	const hasExpiringSoon = isExpiringSoon(checkExpiringSoon, checkExpiresAt);

	if (hasExpired) {
		return (
			<Badge variant="destructive" className="gap-1">
				<HugeiconsIcon
					icon={AlertDiamondIcon}
					strokeWidth={2}
					className="size-3"
				/>
				Expirováno
			</Badge>
		);
	}

	if (hasExpiringSoon) {
		return (
			<Badge variant="warning" className="gap-1">
				<HugeiconsIcon icon={Time04Icon} strokeWidth={2} className="size-3" />
				Expiruje brzy
			</Badge>
		);
	}

	return (
		<Badge variant="default" className="gap-1">
			<HugeiconsIcon icon={Tick02Icon} strokeWidth={2} className="size-3" />
			Zkontrolováno
		</Badge>
	);
}
